module.exports = __webpack_public_path__ + "img/delete.12333ffe.svg";